import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { estrellas } from "../../funcionesDatos/Textos";

// Reserva completada → muestra las estrellas que dejó el comprador o, si no reseñó, el botón para enviarle
// un recordatorio manual (correo + campanita + push) vía /admin/enviar-recordatorio-resena.
// Se usa en /admin/reservas (pestaña Completadas) y en /admin/resenas (pestaña Sin reseña).
// Detiene el clic para no abrir la reserva cuando la tarjeta es clicable.
// Props: reserva (con resena, recordatorioResenaManualEn, recordatoriosResenaManuales), alEnviar(idReserva, datos)

const ESPERA_RECORDATORIO_MS = 24 * 60 * 60 * 1000; // mismo límite que el backend

function fmt(fecha) {
    if (!fecha) return "—";
    return new Date(fecha).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}


function BloqueResenaCompletada({ reserva, alEnviar }) {
    const [enviando, setEnviando] = useState(false);

    if (reserva.resena) {
        const n = Number(reserva.resena.calificacion) || 0;
        return (
            <div className="d-flex align-items-center gap-2 flex-shrink-0" title={reserva.resena.tieneComentario ? "Calificó y dejó comentario" : "Calificó sin comentario"}>
                <span style={{ color: "var(--ambar-600)", letterSpacing: 1 }}>{estrellas(n)}</span>
                <span className="fw-semibold small">{n}/5</span>
                {reserva.resena.tieneComentario ? <i className="bi bi-chat-left-text text-muted small"></i> : null}
            </div>
        );
    }

    const ultimo     = reserva.recordatorioResenaManualEn ? new Date(reserva.recordatorioResenaManualEn) : null;
    const enEspera   = !!ultimo && (Date.now() - ultimo.getTime()) < ESPERA_RECORDATORIO_MS;
    const envios     = Number(reserva.recordatoriosResenaManuales || 0);

    async function enviar(e) {
        e.stopPropagation();
        const confirmacion = await Swal.fire({
            icon: "question",
            title: "¿Enviar recordatorio de reseña?",
            text: "Le llegará al comprador por correo, campanita y notificación push.",
            showCancelButton: true,
            confirmButtonText: "Sí, enviar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "var(--azul-logo-fondo)",
        });
        if (!confirmacion.isConfirmed) return;

        try {
            setEnviando(true);
            const res = await axios.post("/admin/enviar-recordatorio-resena", { params: { idReserva: reserva._id } });
            alEnviar(reserva._id, res.data);
            Swal.fire({ icon: "success", title: "Recordatorio enviado", text: res.data?.mensaje, confirmButtonColor: "var(--azul-logo-fondo)" });
        } catch (err) {
            Swal.fire({ icon: "info", title: "No se envió", text: err?.response?.data?.mensaje || "No se pudo enviar el recordatorio.", confirmButtonColor: "var(--azul-logo-fondo)" });
        } finally {
            setEnviando(false);
        }
    }

    return (
        <div className="d-flex flex-column align-items-end gap-1 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex align-items-center gap-2">
                <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--rojo-error-rgb), 0.08)", color: "var(--rojo-error)", fontSize: "0.72rem" }}>
                    Sin reseña
                </span>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-primary rounded-pill px-3"
                    disabled={enviando || enEspera}
                    onClick={enviar}
                    title={enEspera ? "Ya se envió un recordatorio manual en las últimas 24 h" : "Enviar correo, campanita y push al comprador"}
                >
                    <i className="bi bi-send me-1"></i>{enviando ? "Enviando…" : "Enviar recordatorio"}
                </button>
            </div>
            {ultimo ? (
                <small className="text-muted" style={{ fontSize: "0.72rem" }}>
                    Último envío manual: {fmt(ultimo)}{envios > 1 ? ` · ${envios} envíos` : ""}
                </small>
            ) : null}
        </div>
    );
}

export default BloqueResenaCompletada;
